import { connect } from 'react-redux'
import SortMenuView from 'components/ConversationList/Header/TitleBar/SortMenu'
import { selectSortOptionsByCurrentQueryId } from 'ducks/searches/selectors/selectSortOptionsByCurrentQueryId'

const select = state => ({
  options: selectSortOptionsByCurrentQueryId(state),
})

export default connect(select)(SortMenuView)
